export const Datachain = {
	CachedLang: 'hdh_lang',
};

export const FILTER_MODEL_ID = 'filter-model-id';
export const COLUMN_MODEL_ID = 'column-model-id';
export const PROFILE_ID = 'profile-id';
